import { Dispatch } from 'react';
import { createNamedContext } from '@utils';
import { FormAction, FormState } from './interfaces';

type FormStateContextValue<T extends {} = {}> = [FormState<T>, Dispatch<FormAction<T>>];
type CompositeFormStateContextValue<T extends {} = {}> = [T, Dispatch<{ [K in keyof T]: T[K]; }>];

export const FormStateContext = createNamedContext<FormStateContextValue | undefined>(undefined, 'FormStateContext');
export const FormDerivedEditStateContext = createNamedContext<boolean | undefined>(undefined, 'FormDerivedEditStateContext');
export const CompositeFormStateContext = createNamedContext<CompositeFormStateContextValue | undefined>(undefined, 'CompositeFormStateContext');